// MIDI note range: C2 (36) to C6 (84) = 49 keys (4 octaves + 1)
export const MIDI_MIN = 36; // C2
export const MIDI_MAX = 84; // C6
export const MIDI_COUNT = MIDI_MAX - MIDI_MIN + 1;
export const MIDDLE_C = 60; // C4

const NOTE_NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];

export function midiToNoteName(midi) {
  const octave = Math.floor(midi / 12) - 1;
  return `${NOTE_NAMES[midi % 12]}${octave}`;
}

export function isBlackKey(midi) {
  return [1, 3, 6, 8, 10].includes(midi % 12);
}

// A4 (69) = 440Hz
export function midiToFrequency(midi) {
  return 440 * Math.pow(2, (midi - 69) / 12);
}

// Playback rate for pitch-shifting a sample recorded at middle C
export function midiToPlaybackRate(midi) {
  return Math.pow(2, (midi - MIDDLE_C) / 12);
}
